<template>
  <b-button 
    :disabled="disabled"
    :type="type"
    :target="target"
    :to="to"
    :href="href"
    :size="size"
    :variant="variant"
    :form="form"
    @click="clickableLinkEvent"
    :class="{ 'icon-right': iconRight, 'icon-only': !text }"
  >
    <span v-if="iconRight">{{ text }}</span>
    <font-awesome-icon v-if="icon" :icon="icon" />
    <slot name="icon" />
    <span v-if="!iconRight">{{ text }}</span>
  </b-button>
</template>

<script>
/**
 * NEW:
 * - Added fontawesome 6.2 icons
 * UPDATED PROPS:
 * - removed WIDTH
 * - updated TYPE -> 'button', 'submit' or 'reset' (not for styling)
 * - added SIZE -> 'lg', null or 'sm'
 * - added HREF, TO and TARGET (for linking)
 * - added DISABLED
 * - added FORM (?)
 */
export default {
  name: "GekkoButton",
  data () {
    return {
      buttonType: "full",
    }
  },
  props: {
    variant: {
      type: String,
      default: 'primary',
    },
    icon: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      default: '',
    },
    iconRight: {
      type: Boolean,
      default: false    
    },
    size: {
      type: String,
      default: null
    },
    type: {
      type: String,
      default: 'button'
    },
    href: {
      type: String,
      default: null
    },
    to: {
      type: [Object, String],
      // type: String,
      default: null
    },
    target: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    form: {
      type: String,
      default: null
    },
    pill: {
      type: Boolean,
      default: false
    }
  },
  created () {
  },
  methods: {
    clickableLinkEvent (e) {
      this.$emit('click', e);
    }
  }
}
</script>

<style scoped lang="scss">

</style>
